import { render, staticRenderFns } from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=template&id=70a39adc&scoped=true&lang=pug&"
import script from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminCustomerClassroomManagerAdd.vue?vue&type=style&index=0&id=70a39adc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a39adc",
  null
  
)

export default component.exports